import _ from 'lodash';
import transformInstructions from './instructionsCurriculum';
import { INITIAL_ONBOARDING_LEVELS } from '../data/constants';

let curriculum = {};

export const setCurriculum = (c) => { curriculum = c; };

let audioMap = {};

export const setAudioMap = (a) => {
  audioMap = a;
};

export const getAudioMap = () => audioMap;

let imageMap = {};

export const setImageMap = (i) => {
  imageMap = i;
};

export const getImageMap = () => imageMap;

export const retrieveQueue = (level, set) => _.shuffle(curriculum.levels[`level_${level}`][`set_${set}`]);

export const retrieveInstructionContent = () => {
  const {
    categories,
    c_words,
    q_words,
    target_cell,
    vowels,
  } = curriculum.instruction;
  return transformInstructions(categories, target_cell, vowels, c_words, q_words);
};

export const retrieveOnboardingQueue = (level) => {
  const setNumber = INITIAL_ONBOARDING_LEVELS.includes(level) ? 0 : 1;
  return curriculum.onboarding[`set_${setNumber}`];
};

export const retrieveOnboardingCategories = (level) => {
  const setNumber = INITIAL_ONBOARDING_LEVELS.includes(level) ? 0 : 1;
  return curriculum.onboarding.categories[setNumber];
};
